import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Input, ListGroup, ListGroupItem } from 'reactstrap';

class Autocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array),
  };
  static defaultProps = {
    suggestions: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: '',
      selectedValue: '',
      isNotInSuggestions: false,
      isAlreadyUpdated: false,
      lastValue: ''
    };

    this.autoCompleteRef = createRef();
  }

  componentDidUpdate() {
    if (this.props.updateValue && this.props.updateValue != this.state.lastValue) {

      this.setState({
        isAlreadyReset: true,
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: '',
        selectedValue: '',
        lastValue: this.props.updateValue
      });
    }


    if (this.props.defaultValue && this.props.defaultValue != '' && this.state.isAlreadyUpdated == false)
      this.setDefaultValue(this.props.defaultValue, false);


    if (this.props.injectedValue && this.props.injectedValue != '' && this.state.isAlreadyUpdated == false)
      this.setDefaultValue(this.props.injectedValue, true);
  }

  setDefaultValue = (val, isFromInject) => {

    if (this.props.suggestions.length > 0 && (this.props.form[this.props.dataValue] == '' || isFromInject)) {
      const { suggestions } = this.props;

      let selectedSuggestion = suggestions.filter((item) => item[this.props.dataKey] == String(val));
      if (selectedSuggestion) {
        selectedSuggestion = suggestions.filter((item) => item[this.props.dataValue] == String(val));
      }
      if (selectedSuggestion.length == 1) {
        this.setState({
          activeSuggestion: 0,
          filteredSuggestions: [],
          showSuggestions: false,
          userInput: selectedSuggestion[0][this.props.dataValue],
          selectedValue: selectedSuggestion[0][this.props.dataKey],
        });

        if (isFromInject) {
          this.setState({ isAlreadyUpdated: true });
        }

        let currentTarget = { name: this.props.name, value: selectedSuggestion[0][this.props.dataKey] };
        this.props.onSelectedChange({ target: currentTarget, form: this.props.form });
      } else {
        let currentTarget = { name: this.props.name, value: ' ' };
        this.props.onSelectedChange({ target: currentTarget, form: this.props.form });
        this.setState({
          isAlreadyUpdated: true,
          activeSuggestion: 0,
          filteredSuggestions: [],
          showSuggestions: false,
          userInput: '',
          selectedValue: '',
        });
      }
    }
  };

  onChange = (e) => {
    const { suggestions } = this.props;
    const userInput = e.currentTarget.value.replace(/’/g, "'");;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = suggestions.filter(
      (suggestion) => suggestion[this.props.dataValue].toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    // Update the user input and filtered suggestions, reset the active
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });
  };

  onClick = (e) => {
    // Update the user input and reset the rest of the state
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.textContent,
      selectedValue: e.currentTarget.selected,
    });

    let currentTarget = { name: this.props.name, value: e.currentTarget.selected };
    this.props.onSelectedChange({ target: currentTarget, form: this.props.form });
  };

  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;
    // User pressed the enter key, update the input and close the

    //clear value if pressed delete or back space
    if (e.keyCode === 8 || (e.keyCode === 46 && this.state.selectedValue !== '')) {
      let currentTarget = { name: this.props.name, value: '' };
      this.props.onSelectedChange({ target: currentTarget, form: this.props.form });
    }

    // suggestions
    if (e.keyCode === 13) {
      e.preventDefault();
      this.setState({
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion][this.props.dataValue],
        selectedValue: filteredSuggestions[activeSuggestion][this.props.dataKey],
      });

      let currentTarget = { name: this.props.name, value: filteredSuggestions[activeSuggestion][this.props.dataKey] };
      this.props.onSelectedChange({ target: currentTarget, form: this.props.form });
    }
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion - 1 });

      let tempId = '#val' + (parseInt(activeSuggestion) - parseInt(1));
      let elSuggestion = document.querySelector(tempId);
      elSuggestion.scrollIntoView(false);
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion === filteredSuggestions.length - 1) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion + 1 });

      let tempId = '#val' + (parseInt(activeSuggestion) + parseInt(1));
      let elSuggestion = document.querySelector(tempId);
      elSuggestion.scrollIntoView(false);
    }
  };
  render() {
    const hdnName = this.props.name + 'Key';
    let formControl = 'form-control';
    let errorMsg = '';
    let isNoSuggestions = false;

    if (this.props.error && this.props.error.length > 0 && this.state.selectedValue !== '') {
      formControl = 'input-error';
      errorMsg = this.props.error;
    }

    const {
      onChange,
      onClick,
      onKeyDown,
      state: { activeSuggestion, filteredSuggestions, showSuggestions, userInput, selectedValue },
    } = this;
    let suggestionsListComponent;
    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ListGroup className='suggestions'>
            {filteredSuggestions.map((suggestion, index) => {
              let className;
              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'suggestion-active';
              }
              return (
                <ListGroupItem
                  className={className}
                  id={'val' + index}
                  key={index}
                  selected={suggestion[this.props.dataKey]}
                  onClick={onClick}>
                  {suggestion[this.props.dataValue]}
                </ListGroupItem>
              );
            })}
          </ListGroup>
        );
      } else {
        isNoSuggestions = true;
        if (this.props.resultsNotFound) {
          this.props.resultsNotFound({ name: this.props.name, value: true });
        }
        suggestionsListComponent = <div className='no-suggestions'>לא נמצאו תוצאות</div>;
      }
    }
    return (
      <div className='autocomplete-container'>
        <div className='auto-complete-input'>
          <label className={`has-float-${this.props.required ? 'label-required' : 'label'}`}>
            <Input
              innerRef={this.autoCompleteRef}
              autoFocus={this.props.autofocus}
              className={formControl}
              name={this.props.name}
              id={this.props.id}
              placeholder={this.props.placeholder}
              disabled={this.props.disabled}
              type='text'
              autoComplete='off'
              onChange={onChange}
              onKeyDown={onKeyDown}
              value={userInput}
            />

            <span>{this.props.placeholder}</span>
            {this.props.error && this.props.error.length > 0 && !isNoSuggestions && <div className='error'>{errorMsg}</div>}
          </label>
          <Input type='hidden' name={hdnName} value={selectedValue} />
          {suggestionsListComponent}
        </div>
      </div>
    );
  }
}
export default Autocomplete;
